import { Typography } from '@mui/material';
import { useEffect } from 'react';

export const GroupContent = () => {
	useEffect(() => {
		const ilContentContainer = document.querySelector('#ilContentContainer #il_center_col');
		const groupContent = document.getElementById('group-content');
		if (ilContentContainer && groupContent && ilContentContainer.innerHTML.trim() !== '') {
			ilContentContainer.classList.forEach((key) => {
				ilContentContainer.classList.remove(key);
			});
			groupContent.replaceWith(ilContentContainer);
		}
	}, []);

	return (
		<div id='group-content'>
			<Typography>Bisher wurden keine zusätzlichen Inhalte eingestellt.</Typography>
		</div>
	);
};
